import HomeCareBookRepository from '@/js/repositories/HomeCareBookRepository'

const state = {
	vaccinations: [],
	base: [],
	allergy: [],
	medical_histories: [],
	visited_hospital: [],
    tube_feeding: [],
    suction: [],
    oxygen: [],
    center_nutrition: [],
    dialysis: [],
    peritoneal_dialysic: [],
    ventilator: [],
    insulin: [],
    homecarePdf: null,
    vaccinPdf: null,
    allergyPdf: null,
}

const getters = {

}

const actions = {
	setHomecarePDF({ commit }, data) {
		commit('HOME_CARE_PDF', data)
	},
	setVaccinPDF({ commit }, data) {
		commit('VACCIN_PDF', data)
	},
	setAllergyPDF({ commit }, data) {
		commit('ALLERGY_PDF', data)
	},
	async getBasicInfo({ commit }, data) {
		await HomeCareBookRepository.getHomeCareBook(data)
			.then(res => {
				switch (data.params.group_name) {
					case 'vaccination':
						commit('VACCINATION', JSON.parse(JSON.stringify(res.data.data)))
						break
					case 'base':
						commit('BASE', JSON.parse(JSON.stringify(res.data.data)))
						break
					case 'allergy':
						commit('ALLERGY', JSON.parse(JSON.stringify(res.data.data)))
						break
					case 'medical_history':
						commit('MEDICAL_HISTORIES', JSON.parse(JSON.stringify(res.data.data)))
						break
					case 'visited_hospital':
						commit('VISITED_HOSPITAL', JSON.parse(JSON.stringify(res.data.data)))
						break
					}
			})
			.catch(error => {
				switch (data.params.group_name) {
					case 'vaccination':
						commit('VACCINATION', '')
						break
					case 'base':
						commit('BASE', '')
						break
					case 'allergy':
						commit('ALLERGY', '')
						break
					case 'medical_history':
						commit('MEDICAL_HISTORIES', '')
						break
					case 'visited_hospital':
						commit('VISITED_HOSPITAL', '')
						break
					}
			})
	},
    async getHomeCareInfo({ commit }, data) {
		await HomeCareBookRepository.getHomeCareBook(data)
			.then(res => {
				switch (data.params.group_name) {
					case 'tube_feeding':
						commit('TUBE_FEEDING', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'suction':
						commit('SUCTION', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'oxygen':
						commit('OXYGEN', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'center_nutrition':
						commit('CENTER_NUTRITION', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'dialysis':
						commit('DYALYSIS', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'peritoneal_dialysic':
						commit('PERITONEAL_DIALYSIC', JSON.parse(JSON.stringify(res.data.data)))
						break
					case 'ventilator':
						commit('VENTILATOR', JSON.parse(JSON.stringify(res.data.data)))
						break
                    case 'insulin':
						commit('INSUIN', JSON.parse(JSON.stringify(res.data.data)))
						break
                }
			})
			.catch(error => {
				switch (data.params.group_name) {
					case 'tube_feeding':
						commit('TUBE_FEEDING', [])
						break
                    case 'suction':
						commit('SUCTION', [])
						break
                    case 'oxygen':
						commit('OXYGEN', [])
						break
                    case 'center_nutrition':
						commit('CENTER_NUTRITION', [])
						break
                    case 'dialysic':
						commit('DYALYSIS', [])
						break
                    case 'peritoneal_dialysic':
						commit('PERITONEAL_DIALYSIC', [])
						break
					case 'ventilator':
						commit('VENTILATOR', [])
						break
                    case 'insulin':
						commit('INSUIN', [])
						break
                }
			})
	}
}

const mutations = {
	HOME_CARE_PDF(state, data) {
		state.homecarePdf = data
	},
	VACCIN_PDF(state, data) {
		state.vaccinPdf = data
	},
	ALLERGY_PDF(state, data) {
		state.allergyPdf = data
	},
  	VACCINATION(state, data) {
    	state.vaccinations = data
	},
	BASE(state, data) {
    	state.base = data
	},
	ALLERGY(state, data) {
    	state.allergy = data
	},
	MEDICAL_HISTORIES(state, data) {
    	state.medical_histories = data
	},
	VISITED_HOSPITAL(state, data) {
    	state.visited_hospital = data
	},
    TUBE_FEEDING(state, data) {
    	state.tube_feeding = data
	},
    SUCTION(state, data) {
    	state.suction = data
	},
    OXYGEN(state, data) {
    	state.oxygen = data
	},
    CENTER_NUTRITION(state, data) {
    	state.center_nutrition = data
	},
    DYALYSIS(state, data) {
    	state.dialysis = data
	},
    PERITONEAL_DIALYSIC(state, data) {
    	state.peritoneal_dialysic = data
	},
    VENTILATOR(state, data) {
    	state.ventilator = data
	},
    INSUIN(state, data) {
    	state.insulin = data
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}